import { render, staticRenderFns } from "./dnaBarIndex.vue?vue&type=template&id=1b238cdf&scoped=true&"
import script from "./dnaBarIndex.vue?vue&type=script&lang=js&"
export * from "./dnaBarIndex.vue?vue&type=script&lang=js&"
import style0 from "./dnaBarIndex.vue?vue&type=style&index=0&id=1b238cdf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b238cdf",
  null
  
)

export default component.exports